import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColors from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        padding: theme.spacing(2.5),
      },
      box: {
        borderRadius: 4,
        backgroundColor: sicrediColors.secondarySicrediLightest,
      },
      title: {
        fontWeight: 'bold',
        fontSize: 16,
        color: sicrediColors.secondarySicrediDarker,
        letterSpacing: 0.25,
        lineHeight: 1.5,
        padding: theme.spacing(1),
        borderBottomWidth: 16,
        borderBottomColor: 'white',
        whiteSpace: 'pre-wrap',
      },
      data: {
        fontWeight: 300,
        fontSize: 16,
        color: sicrediColors.secondarySicrediDark,
        letterSpacing: 0.44,
        lineHeight: 1.5,
        padding: theme.spacing(2, 1),
      },
    }),
  { name: 'ListagemLoginsContas' }
);
